export class TaikyoForInput {
    taikyoReasons = [];
    taikyoDateMinDays = 0;
    taikyoDateMaxDays = 0;
    taikyoMaxDate = null;
    taikyoMaxDate = null;
}
